import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import DepositModal from "../components/DepositModal";

function Stocklist() {
  const { user } = useUser();
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const symbol = params.get('symbol');
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [stock, setStock] = useState();
  const [amount, setAmount] = useState();
  const [stocklist, setStocklist] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [allstocking, setAllstocking] = useState([]);
  const [stockBal, setStockBal] = useState(0);
  useEffect(() => {
    if (!symbol) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php?symbol=${encodeURIComponent(symbol)}`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStock: true, symbol:symbol })
    })
    .then(response => response.json())
    .then(data => {
        setStock(data);
        setLoading(false);
    })
    .catch(err => {
        window.location.href = '/stock';
    })
  }, [symbol]);
  useEffect(() => {
    if (!symbol) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStockBal: true, symbol:symbol })
    })
    .then(response => response.json())
    .then(data => {
        if(data.status == "success"){
          setStockBal(data.balance);
        }
    })
    .catch(err => {
        window.location.href = '/stock';
    })
  }, [symbol]);
  useEffect(() => {
    if (!symbol) return;
    fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const stockList = Object.values(data);
        const stock = stockList.find(item => item.symbol === symbol);
        if (stock) {
          const updatedStock = {
            id: 1,
            logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
            name: stock.name,
            type: 'stock',
            symbol: stock.symbol,
            price: Number(Number(stock.price).toFixed(2)),
          };
          setStocklist(updatedStock);
        } else {
          setStocklist(null);
        }
      })
      .catch((err) => console.error("Error loading stock:", err));
  }, [symbol]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchmyStockes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setAllstocking(data.mystocks);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);

  //COMPONENT ATTACHMENTS
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  function formatNumber(num) {
    if (num === null || num === undefined) return '';
    num = Number(num);
    if (isNaN(num)) return num;
  
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(2).replace(/\.00$/, '') + ' B';
    } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(2).replace(/\.00$/, '') + ' M';
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(2).replace(/\.00$/, '') + ' K';
    } else {
      return num.toString();
    }
  }

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#31acee', opacity: '0.5'}} spin /></div>;
  }
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Stock" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Stock" icon={<FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-6">
                <div className="mycard mt-2">
                    <div className="overflow-hidden d-flex align-items-center justify-content-center mb-3 rounded-circle" style={{width:'50px',height:'50px',backgroundColor:'#ffffff4d'}}>
                        <img src={stocklist.logo} alt={stocklist.symbol} style={{width: '100%'}} />
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h5 className="mb-2 fw-bolder" style={{color:'gray'}}>{stocklist.name}</h5>
                        <h5 className="mb-0 fw-bolder">{getCurrencySymbol(user?.currency)}{formatCurrency(stocklist.price * rate)}</h5>
                      </div>
                      <div className="text-end">
                        <h6 className="mb-0" style={{color:'gray', fontSize:'14px'}}>BALANCE</h6>
                        <h5 className="mb-0 fw-bolder">{formatCurrency(stockBal)} {stocklist.symbol}</h5>
                      </div>
                    </div>
                    <p className="mb-0 fw-semibold lh-1 mt-1" style={{fontSize:'12px', color: stock.change < 0 ? 'red' : 'green'}}>({stock.change})</p>
                    <p className="mb-0 fw-semibold lh-1"><span style={{fontSize:'12px', color: stock.percent_change < 0 ? 'red' : 'green'}}>({stock.percent_change})</span> <span style={{fontSize:'12px'}}>Today</span></p>
                    <div class="rounded-0 w-100 bg-primary py-2 fw-bold mt-3 d-flex justify-content-center" style={{cursor: 'pointer'}} onClick={() => setIsOpen(true)}>Get Started</div>
                    <p className="mt-4 mb-3 fw-bold">Stats</p>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Open</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.open * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Volume</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{formatNumber(stock.volume)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>High</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.high * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Avg Vol</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{formatNumber(stock.average_volume)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Low</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.low * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Mkt Cap</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{formatNumber(stock.close * stock.average_volume)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>52 Wk High</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.fifty_two_week.high * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>52 Wk Low</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.fifty_two_week.low * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0" style={{color:'gray',fontSize:'14px'}}>Div/Yield</p>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(stock.previous_close * rate)}</p>
                            </div>
                            <hr className="my-2" style={{opacity:'0.1'}}/>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mycard mt-2">
                    {allstocking.length > 0 ? (
                    <div className="table-responsive scrollDown">
                        <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th className="text-nowrap">Purchase Price</th>
                                    <th>Amount</th>
                                    <th className="text-nowrap">Invetment Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {allstocking.map((stocking, key) => (
                            <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{stocking.name} ({stocking.symbol})</td>
                                <td>{getCurrencySymbol(user?.currency)}{formatCurrency(stocking.pur_price * rate)}</td>
                                <td className="text-success">{getCurrencySymbol(user?.currency)}{formatCurrency(stocking.amount * rate)}</td>
                                <td className="text-nowrap">{stocking.date}</td>
                                <td style={{color: stocking.status === 'active' ? 'green' : stocking.status === 'closed' ? 'red' : 'orange'}}>{stocking.status === 'active' ? 'Active' : stocking.status === 'closed' ? 'Closed' : 'Pending'}</td>
                            </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    ) : (
                    <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
                        <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
                        <p className=" mb-0 fw-semibold">No stock investment yet.</p>
                    </div>
                    )}
                </div>
              </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white fs-4" style={{fontSize: '15px'}}>Stock Investment</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="my-3 text-light fw-semibold" style={{fontSize: '15px'}}>To invest in {stocklist.name} stock, enter the amount you wish to invest and confirm your purchase. Your investment will be processed at the current market price.</p>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                  type="number"
                  placeholder="0.00000000"
                  className="inputNone"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  {user?.currency}
                </div>
            </div>
            <div
              className={`myBtn w-100 text-center mt-3 ${!amount ? 'disabled' : ''}`}
              style={{
                paddingTop: '12px',
                paddingBottom: '12px',
                pointerEvents: !amount ? 'none' : 'auto',
                opacity: !amount ? 0.6 : 1,
              }}
              onClick={
                user?.stock != "1"
                  ? () => setIsOpen2(true)
                  : amount
                  ? () => {
                      setIsOpen1(true);
                      localStorage.setItem('stock.name', stocklist.name);
                      localStorage.setItem('stock.symbol', stocklist.symbol);
                      localStorage.setItem('stock.price', stocklist.price);
                    }
                  : undefined
              }
            >
              {loading1 ? (
                <FontAwesomeIcon
                  icon={faCircleNotch}
                  style={{ fontSize: '20px', color: 'white', opacity: '0.5' }}
                  spin
                />
              ) : (
                'Invest'
              )}
            </div>
        </Modal>
        <DepositModal modalIsOpen={modalIsOpen1} setIsOpen={setIsOpen1} route="Stock" pprice={amount}/>
        <Modal
            isOpen={modalIsOpen2}
            onRequestClose={() => setIsOpen2(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <div></div>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
            </div>

            <div className="d-flex align-items-center justify-content-center">
                <img src="uploads/unavailable.png" alt="Unavailable Stock" style={{width: '200px'}}/>
            </div>

            <p className="fw-semibold mb-2 mt-3 text-center" style={{fontSize: '16px'}}>
                Stock Purchase Unavailable
            </p>

            <p className="text-gray text-center" style={{fontSize: '13px'}}>
                This stock is currently unavailable for purchase. Please contact the administrator for assistance.
            </p>

            <div className="myBtn w-100 text-center mt-4" style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => setIsOpen2(false)}>
                Close
            </div>
        </Modal>

      </div>
    </div>
  )
}

export default Stocklist